import { Icon, IconProps } from '@chakra-ui/react'

export default function NotebookIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        d="M5.99999 4H3.86666C3.20391 4 2.66666 4.53726 2.66666 5.2V12.8C2.66666 13.1183 2.79308 13.4235 3.01813 13.6485C3.24317 13.8736 3.5484 14 3.86666 14H12.1333C12.4516 14 12.7568 13.8736 12.9819 13.6485C13.2069 13.4235 13.3333 13.1183 13.3333 12.8V5.2C13.3333 4.53726 12.7961 4 12.1333 4H9.99999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33334 6.66659H10.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33334 9.00008H10.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33334 11.3333H10.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4V4C10 2.89543 9.10457 2 8 2V2C6.89543 2 6 2.89543 6 4V4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
